import React from "react";
import { useAuth } from "../../context/AuthContext";

export default function OperatorSettingsPage() {
    const { user } = useAuth();
    return (
        <div data-testid="operator-settings-page">
            <div className="mb-8">
                <h1 className="text-3xl font-display font-bold text-white">Settings</h1>
                <p className="text-sm text-gray-500 mt-1">Your operator account.</p>
            </div>
            <div className="bg-card border border-border/40 p-6">
                <div className="grid grid-cols-2 gap-y-3 text-sm">
                    <span className="text-gray-500">Name</span><span className="text-white font-mono">{user?.full_name}</span>
                    <span className="text-gray-500">Email</span><span className="text-white font-mono">{user?.email}</span>
                    <span className="text-gray-500">Role</span><span className="text-emerald-300 font-mono">company_operator</span>
                </div>
            </div>
        </div>
    );
}
